// extracted by mini-css-extract-plugin
export var footer = "_jx-0";
export var inherit = "_jx-1";
export var input = "_jx-2";
export var modalContent = "_jx-3";
export var quillEditor = "_jx-4";
export var subtitle = "_jx-5";